<template>
  <div class="row mt-2 mb-2" v-if="data.length > 0">
    <div class="col-md-12 mb-1">
      <label class="font-w600">{{ data[0].title[lang] }}</label>
    </div>
    <div class="col-md-3 mb-3">
      <div class="custom-control custom-block custom-control-primary">
        <input
          :id="'item1' + group"
          type="radio"
          class="custom-control-input"
          :name="'products[' + group + '][subscription]'"
          value="0"
          v-model="data[0].status"
        />
        <label class="custom-control-label" :for="'item1' + group">
          <span class="d-flex align-items-center">
            <span class="ml-2">
              <span class="font-w700">{{ translate[lang]["no"] }}</span>
            </span>
          </span>
        </label>
        <span class="custom-block-indicator">
          <i class="fa fa-check"></i>
        </span>
      </div>
    </div>
    <div class="col-md-3 mb-3">
      <div class="custom-control custom-block custom-control-primary">
        <input
          :id="'item2' + group"
          type="radio"
          class="custom-control-input"
          :name="'products[' + group + '][subscription]'"
          value="1"
          v-model="data[0].status"
        />
        <label class="custom-control-label" :for="'item2' + group">
          <span class="d-flex align-items-center">
            <span class="ml-2">
              <span class="font-w700">{{ translate[lang]["yes"] }}</span>
            </span>
          </span>
        </label>
        <span class="custom-block-indicator">
          <i class="fa fa-check"></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { PrefillMixin } from "../../views/Mixins/PrefillMixin";
import { mapState } from "vuex";
export default {
  name: "Subscription",
  data() {
    return {};
  },
  props: ["data", "group"],
  mixins: [PrefillMixin],
  computed: {
    ...mapState({
      submitData: state => state.forms.SubmitData
    })
  },
  mounted() {
    // this method needs to run after render, I didnt find any other solution. Please change if you know...
    if (
      this.submitData.products[this.group] &&
      this.submitData.products[this.group].subscription
    ) {
      this.data[0].status = this.submitData.products[this.group].subscription;
    }
  }
};
</script>

<style scoped></style>
